import "./SimpleEvenFlex.css";

const SimpleEvenFlex = ({children, fullWidth = false, enforceEven = true, growUp = true, extraStyle, degradeStackOnMobile = false, invertDirections = false}) => (
    <div className={`simple-flex ${fullWidth ? "full-width-flex" : ""} ${enforceEven ? "even-flex" : ""} ${growUp ? "grow-up" : "no-grow-up"} ${degradeStackOnMobile ? "allow-degraded-stack" : ""} ${invertDirections ? "inverted-stack" : ""}`} style={extraStyle}>
        {children}
    </div>
);

export default SimpleEvenFlex;